import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class KPIPercentageModel extends BaseModel {
  @attr("string") value;
  @attr("string") label;
  @attr("string") performanceText;
}
